import { TextOutlinedInput, TextAreaInput } from '@octano/global-ui';
import { useFormContext } from 'react-hook-form';
import { Col } from 'reactstrap';
import { AzureFilesUploaderControlled } from '../../../../../components/AzureFilesUploader/AzureFileUploaderControlled';
import { FileRequiredTypes } from '../../../../../components/AzureFilesUploader/types';
import { useValidations } from '../../../../../hooks/useValidations';
import { useTexts } from '../hooks/useTexts';

export interface FormData {
  name: string;
  description: string;
  file: {
    id: number;
    name: string;
  } | null;
}

export function StudentDocumentForm() {
  const { modal } = useTexts();
  const texts = modal.inputs;
  const forms = useFormContext<FormData>();
  const { control } = forms;
  const { msgValidations } = useValidations();

  return (
    <>
      <Col xs={12}>
        <TextOutlinedInput
          name="name"
          label={texts.name.label}
          placeholder={texts.name.placeholder}
          control={control}
          rules={{ required: msgValidations.required }}
        />
      </Col>
      <Col xs={12} className="mt-4">
        <TextAreaInput
          name="description"
          label={texts.description.label}
          placeholder={texts.description.placeholder}
          control={control}
        />
      </Col>
      <Col xs={12} className="mt-4">
        <AzureFilesUploaderControlled
          name="file"
          control={control}
          fileType={FileRequiredTypes.StudentDocument}
          label={texts.file.label}
          rules={{ required: msgValidations.required }}
        />
      </Col>
    </>
  );
}
